// extracted by mini-css-extract-plugin
export default {"filterContainer":"FiltersResponsive_filterContainer__Za5jk","filters":"FiltersResponsive_filters__KRA+X","brands2":"FiltersResponsive_brands2__7rWHQ"};